import React from 'react';
import Loader from '../shared/Loader';
import { generateContent } from '../../helpers/plunger';
import { serviceAPI } from '../../InterfaceAPI/serviceAPI';
import { Redirect } from 'react-router-dom';
import ModalEnabled from '../extend/ModalEnabled';
import SkipWeekModal from '../menuSelection/SkipWeekModal';

const now = new Date().getTime();
const week = 604800 * 1000; // Number of seconds in a week.
const fourWeeksFromNow = now + week * 4;

const SortableList = props => {
  return <div className="cms__list">{renderTable(props)}</div>;
};

const renderTable = props => {
  const {
    columns,
    rows,
    sort,
    handleSort,
    ListItem,
    isLoading,
    currentRoute,
    isPast,
    isClientList
  } = props;

  if (isLoading) return <Loader />;

  if (rows.length <= 0) return <p className="p p--bold">No Results</p>;

  return (
    <div className="SortableList">
      <table className="table">
        <thead>
          <tr className="table__head">
            {renderHead(columns, sort, handleSort)}
          </tr>
        </thead>
        <tbody>
          {rows.map((menu, i) => (
            <ListItem
              key={i}
              menu={menu}
              columns={columns}
              currentRoute={currentRoute}
              isPast={isPast}
            />
          ))}
        </tbody>
      </table>
      <div className="card-view">
        {rows.map((menu, i) => (
          <SortableListCard
            key={i}
            menu={menu}
            columns={columns}
            isClientList={isClientList}
            currentRoute={currentRoute}
            isPast={isPast}
          />
        ))}
      </div>
    </div>
  );
};

// const SortableListCard = props => {
class SortableListCard extends ModalEnabled {
  state = {
    redirect_to: false
  };

  render() {
    const { columns, menu, isClientList, currentRoute, isPast } = this.props;

    if (this.state.redirect_to) return <Redirect to={this.state.redirect_to} />;

    return (
      <div className="SortableListCard">
        {renderCardData(menu, columns)}
        {isClientList && this.renderSelectMenuLink(menu, currentRoute)}
        {isClientList && this.renderSkipLink(menu, isPast)}
        <SkipWeekModal
          isOpen={this.isOpen('skip-week')}
          closeModal={this.closeModal}
          skipWeek={this.handleSkipWeek}
        />
      </div>
    );
  }

  renderSelectMenuLink = (menu, currentRoute) => {
    // Client Dashboard only
    if (!currentRoute.includes('admin')) {
      // If menu not skipped
      if (!menu.skipped) {
        let time = new Date(menu.date).getTime();
        // For services within 4 weeks from now.
        if (time < fourWeeksFromNow && time > now) {
          if (menu.service_type === 'custom_weekly') {
            return (
              <div>
                <a href={`/service/${menu.id}`} className="a--blue">
                  View Service
                </a>
              </div>
            );
          } else if (!menu.menu_selections.length) {
            return (
              <div>
                <a href={`/menu-selection/${menu.id}`} className="a--blue">
                  Select Menu
                </a>
              </div>
            );
          } else {
            return (
              <div>
                <a href={`/service/${menu.id}`} className="a--blue">
                  View Service
                </a>
              </div>
            );
          }
        }
      }
    }
  };

  renderSkipLink = (menu, isPast) => {
    // If service is upcoming
    if (!isPast) {
      // Unless menu selections have already been made render Skip/Unskip
      if (!menu.menu_selections.length) {
        return !menu.skipped ? (
          <div>
            <span
              className="a--blue"
              onClick={() => this.openModal('skip-week')}
            >
              Skip
            </span>
          </div>
        ) : (
          <div>
            <span
              className="a--blue"
              onClick={() => this.handleUnskipWeek(menu)}
            >
              Unskip
            </span>
          </div>
        );
      }
    }
  };

  handleSkipWeek = (reason = '') => {
    const { menu } = this.props;
    serviceAPI
      .skipService(menu.id, reason)
      .then(res => {
        this.setState({ redirect_to: '/' });
      })
      .catch(err => {
        console.error(err);
      });
  };

  handleUnskipWeek = menu => {
    // Will uncomment on next PR where API route added
    serviceAPI
      .unSkipService(menu.id)
      .then(res => {
        console.log(res);
        this.setState({ redirect_to: '/' });
      })
      .catch(err => {
        console.error(err);
      });
  };
}

const renderCardData = (data, columns) => {
  return columns.map((specs, i) => renderCard(data, specs, i));
};

const renderCard = (data, specs, i) => {
  // if there's no prop, return empty
  if (!specs.link && !specs.raw && !data) return <div key={i} />;

  let content = generateContent(data, specs);

  // NOTE: This is not ideal... I do not recommend this.
  if (specs.link && specs.link.label === 'Select Menu') {
    let date = new Date(data.date);
    let time = date.getTime();
    if (time > fourWeeksFromNow) content = null;
  }
  // END NOTE:
  if (!content) return;

  return (
    <div key={i}>
      {specs.label && <b>{specs.label}:</b>}
      {content}
    </div>
  );
};

const renderHead = (columns, sort, handleSort) => {
  return columns.map((item, i) => {
    let classes = `p p--bold table__th ${item.headClass || ''}`;

    if (!item.sortable || item.sortable !== false)
      classes += ` table__th--sortable`;

    const sortOption = sort.find(option => item.key in option);
    if (sortOption && sortOption[item.key])
      classes += ` active active--${sortOption[item.key]}`;

    return (
      <th key={i} className={classes} onClick={() => handleSort(item.key)}>
        {item.label}
      </th>
    );
  });
};

export default SortableList;



// WEBPACK FOOTER //
// ./src/components/shared/SortableList.js